import { axios, API } from './config';

export const standaloneBEOsAPI = {
  getAll: async () => {
    const response = await axios.get(`${API}/standalone-beos`);
    return response.data;
  },
  
  getById: async (id) => {
    const response = await axios.get(`${API}/standalone-beos/${id}`);
    return response.data;
  },
  
  create: async (beoData) => {
    const response = await axios.post(`${API}/standalone-beos`, beoData);
    return response.data;
  },
  
  update: async (id, beoData) => {
    const response = await axios.put(`${API}/standalone-beos/${id}`, beoData);
    return response.data;
  },
  
  delete: async (id) => {
    const response = await axios.delete(`${API}/standalone-beos/${id}`);
    return response.data;
  },
  
  convertToContract: async (id) => {
    const response = await axios.post(`${API}/standalone-beos/${id}/convert-to-contract`);
    return response.data;
  }
};
